import React from 'react';
import PropTypes from 'prop-types';

export const Text = (props) => {
  return <p className="p-tag">{props.content}</p>
};

Text.propTypes = {
  content: PropTypes.string
};



// WEBPACK FOOTER //
// src/client/components/common/CMS/elements/Text.js